export default __webpack_public_path__ + "static/media/star.d4ad20b6.svg";